export function TableHeader({ children }) {
  return (
    <div className='table-header'>
      {children}
    </div>
  );
}
